import emblem from "@/assets/golden-wine-emblem.png";
import { useTranslation } from "react-i18next";
import { scrollToId } from "@/lib/scroll";
import { Phone, Mail, Instagram } from "lucide-react";

const LINK_IDS = ["especialidades", "catalogo", "comparativa", "bodegas", "taller", "faq", "presupuesto"];
const LINK_HREFS = { especialidades: "#especialidades", catalogo: "#catalogo", comparativa: "#comparativa", bodegas: "#bodegas", taller: "#taller", faq: "#faq", presupuesto: "#presupuesto" };

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer data-testid="footer" className="border-t border-[#F5CB5C]/10 bg-[#030508]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img src={emblem} alt="Láser Vintage" className="w-10 h-10 object-contain drop-shadow-[0_0_12px_rgba(245,203,92,0.3)]" />
              <span className="font-display text-white tracking-[0.14em]">LÁSER VINTAGE</span>
            </div>
            <p className="mt-4 text-sm text-gray-500 leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="mt-4">
              <a
                data-testid="footer-instagram-badge"
                href="https://www.instagram.com/laser__vintage"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#F5CB5C]/25 bg-[#24020B]/50 text-xs font-medium text-[#FAE19C] hover:border-[#F5CB5C]/70 hover:text-white hover:shadow-[0_0_16px_rgba(245,203,92,0.25)] transition-all"
              >
                <Instagram size={14} className="text-[#F5CB5C]" />
                <span>@laser__vintage</span>
              </a>
            </div>
          </div>
          <nav className="flex flex-col gap-2.5 text-sm">
            {LINK_IDS.map((id) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(LINK_HREFS[id])} className="text-left text-gray-400 hover:text-[#F5CB5C] transition-colors">
                {t(`footer.links.${id}`)}
              </button>
            ))}
          </nav>
          <div className="text-sm text-gray-500">
            <div className="text-[10px] uppercase tracking-[0.24em] text-[#F5CB5C]/70 font-semibold mb-3">{t("footer.addressKicker")}</div>
            <p className="leading-relaxed">{t("footer.addressLine1")}<br />{t("footer.addressLine2")}<br />{t("footer.addressLine3")}</p>
            <div className="mt-4 pt-3 border-t border-white/5 flex flex-col gap-2 text-xs text-gray-400">
              <a href="tel:+34652463252" className="inline-flex items-center gap-2 hover:text-[#F5CB5C] transition-colors">
                <Phone size={14} className="text-[#F5CB5C]" />
                <span className="tabular-nums">652 463 252</span>
              </a>
              <a href="mailto:info@laservintage.es" className="inline-flex items-center gap-2 hover:text-[#F5CB5C] transition-colors">
                <Mail size={14} className="text-[#F5CB5C]" />
                <span>info@laservintage.es</span>
              </a>
              <a
                data-testid="footer-instagram-link"
                href="https://www.instagram.com/laser__vintage"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-[#F5CB5C] transition-colors"
              >
                <Instagram size={14} className="text-[#F5CB5C]" />
                <span>@laser__vintage</span>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-gray-600">
          <span data-testid="footer-copyright">{t("footer.copyright")}</span>
          <span>{t("footer.bottomNote")}</span>
        </div>
      </div>
    </footer>
  );
}
